import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  href?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CtaButton({
  label,
  href = CHECKOUT_URL,
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl px-6 py-4 text-center font-display text-base font-extrabold uppercase leading-tight tracking-tight sm:text-lg transition-[transform,background-color,box-shadow] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink active:translate-y-[2px]';
  const styles = variant === 'primary' ? 'bg-naranja text-white shadow-cta hover:bg-naranja-dark active:shadow-[0_3px_0_0_#c8431d] focus-visible:outline-naranja-dark' : 'bg-cream text-ink shadow-[0_6px_0_0_#0b4c36] hover:bg-white active:shadow-[0_3px_0_0_#0b4c36]';
  return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-29" data-mp="35yh9s5azha69">
      <span className="font-bold" data-id="element-30" data-mp="39y7wnxxe365i">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="39z17pb3dshtg" />
    </a>;
}